<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="blog-slider" >
                <template #default>   <m-content-slider-2 v-bind='{...{"contentType":"post","contentCategory":["header-slider"],"contentCard":"mContentCard910","autoPlay":false,"autoPlayDuration":1000},...{}}' :style='""' class="col-12 p-0 header-slider" ></m-content-slider-2></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentSlider2 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mContentSlider2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
